export default __webpack_public_path__ + "static/14-bf615457824242368057b7b88b0aea24.jpg";